<template>
  <v-footer
    color="#424242"
    padless
  >
  <p style="color:white;justify-items:center;">Created By : Sashin Agrawal </p>
    
  </v-footer>
</template>

<script>

// import 
export default {
  name      : 'ContactDetails',
  components: {
    
  },
  data: () => ({
    link:''
  }),
  methods: {
  },
}
</script>

<style scoped>
.fill-width {
  width: 100%;
}
.pre {
  white-space: pre;
}
</style>
